// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/index'
import store from './store/index'
import httpUtil from './utils/httpUtil'
import reqUrl from "./constants/requestUrl"
import _ from "lodash"
import VueMarkDown from 'vue-markdown'
Vue.use(ElementUI)
Vue.use(httpUtil)
Vue.use(VueMarkDown)
Vue.config.productionTip = true //prod==false
Vue.config.devtools = true;
Vue.prototype.$reqUrl = reqUrl
Vue.prototype.$_ = _
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js